import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Configure axios defaults
axios.defaults.withCredentials = true;

// Helper to format API errors
export const formatApiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail == null) return "Une erreur s'est produite. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// ==================== AUTH ====================
export const authAPI = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  register: (email, password, name) => axios.post(`${API}/auth/register`, { email, password, name }),
  logout: () => axios.post(`${API}/auth/logout`),
  me: () => axios.get(`${API}/auth/me`),
};

// ==================== ODOO ====================
export const odooAPI = {
  status: () => axios.get(`${API}/odoo/status`),
  getBOMs: (limit = 50) => axios.get(`${API}/odoo/boms`, { params: { limit } }),
  getProducts: (limit = 100) => axios.get(`${API}/odoo/products`, { params: { limit } }),
  getPOSOrders: (limit = 50, days = 7) => axios.get(`${API}/odoo/pos-orders`, { params: { limit, days } }),
  getSalesSummary: (days = 7) => axios.get(`${API}/odoo/pos-sales-summary`, { params: { days } }),
  getSalesAnalysis: (params) => axios.get(`${API}/odoo/sales-analysis`, { params }),
  getPOSCategories: () => axios.get(`${API}/odoo/pos-categories`),
  getPOSStats: (params) => axios.get(`${API}/odoo/pos-stats`, { params }),
};

// ==================== TASKS ====================
export const tasksAPI = {
  getAll: (status = null, date = null) => {
    const params = {};
    if (status) params.status = status;
    if (date) params.date = date;
    return axios.get(`${API}/tasks/`, { params });
  },
  create: (task) => axios.post(`${API}/tasks/`, task),
  update: (taskId, update) => axios.patch(`${API}/tasks/${taskId}`, update),
  assign: (taskId, assignedToIds, assignedToNames) =>
    axios.post(`${API}/tasks/${taskId}/assign`, {
      assigned_to: assignedToIds,
      assigned_to_names: assignedToNames,
    }),
  generateFromBOM: (bomId, covers) => axios.post(`${API}/tasks/generate-from-bom/${bomId}`, null, { params: { covers } }),
};

// ==================== PLANNING ====================
export const planningAPI = {
  getAll: (date = null) => {
    const params = date ? { date } : {};
    return axios.get(`${API}/planning/`, { params });
  },
  create: (entry) => axios.post(`${API}/planning/`, entry),
};

// ==================== TEAMS ====================
export const teamsAPI = {
  getAll: () => axios.get(`${API}/teams/`),
  create: (member) => axios.post(`${API}/teams/`, member),
};

// ==================== TEMPLATES ====================
export const templatesAPI = {
  getAll: () => axios.get(`${API}/templates/`),
  getById: (templateId) => axios.get(`${API}/templates/${templateId}`),
  create: (template) => axios.post(`${API}/templates/`, template),
  generateTasks: (templateId, params) => axios.post(`${API}/templates/${templateId}/generate-tasks`, null, { params }),
};

// ==================== RECIPES ====================
export const recipesAPI = {
  getAll: (search = '') => axios.get(`${API}/recipes/`, { params: search ? { search } : {} }),
  getDetail: (recipeId) => axios.get(`${API}/recipes/${recipeId}`),
  sync: () => axios.post(`${API}/recipes/sync`),
  delete: (recipeId) => axios.delete(`${API}/recipes/${recipeId}`),
};

// ==================== NOTIFICATIONS ====================
export const notificationsAPI = {
  getAll: (unreadOnly = false) => axios.get(`${API}/notifications/`, { params: { unread_only: unreadOnly } }),
  getUnreadCount: () => axios.get(`${API}/notifications/unread-count`),
  markAsRead: (notificationId) => axios.patch(`${API}/notifications/${notificationId}/read`),
  markAllAsRead: () => axios.post(`${API}/notifications/mark-all-read`),
  send: (userId, type, title, message, taskId = null) =>
    axios.post(`${API}/notifications/send`, null, {
      params: { user_id: userId, notification_type: type, title, message, task_id: taskId }
    }),
};
